export const css = {
	root: '_3Mh6n_ig',
	loading: 'iHmMpmH8',
	titleBlock: 'QUZvevBJ',
	title: '_1Q1GU7B-',
	gotitBlock: '_1YVxHOeE',
	gotit: '_2lQHgzjO',
	section: '_3eGABxCQ',
	hero: 'bqVtT-he',
	heroBanner: '_1QGGO3D8',
	heroSubtitle: '_3Q8-jEp_',
	heroIconList: '_2GLeBGOQ',
	verticalAccordion: '_3u-8fRVO',
	accordion: '_3HzG9VmV',
	horizontalAccordion: '_28nOQJ34',
	storyline: '_3DMMV4xB',
	xref: '_2lzp4BHE',
	HCBullet: '_3NJeOaK8',
	HCBulletStyle2: '_1Yi0eer2',
	TableUL: 'mJYa-Kwn',
	figure: '_1GOt0By-',
	nextprev: '_3k8m2Jhy',
	next: '_2DnSybZq',
	previous: '_38meO4ua',
	compactyes: '_2oXm3eWF',
	' _key': 'afcpe-theme/afcpe/micro/book-widgets/topicpage'
};

export default css;
